import React, { useEffect } from 'react';

import ItemResultView from './ItemResultView';
import WithLoading from '../../../Hoc/WithLoading';

export const getItemApi = `/requests/:id`;

const ItemResult = ({ id }) => {
  useEffect(() => {}, [id]);
  return (
    <WithLoading
      component={ItemResultView}
      url={getItemApi.replace(':id', id)}
    />
  );
};

export default React.memo(ItemResult);
